(function () {
  const productsPerRow = () => {
    document.querySelectorAll(".per-row__button").forEach((button) => {
      button.addEventListener("click", function () {
        document.querySelectorAll(".per-row__button").forEach((item) => {
          item.classList.remove("active");
        });

        const perRow = this.dataset.perRow;
        document.querySelectorAll(`[data-per-row="${CSS.escape(perRow)}"]`).forEach((item) => {
          item.classList.add("active");
        });
        document.querySelectorAll("[data-productis-in-row]").forEach((item) => {
          item.setAttribute("data-productis-in-row", perRow);
        });
      });
    });
  };

  document.addEventListener("shopify:section:load", productsPerRow);
  productsPerRow();
})();
